/**
 * Created by Christof Sander on 23.05.2016.
 */

const utils	= require('./utils')

/**
 * this is a linear list of all base components and their template functions.
 * it is used to initialize the components, functions and styles.
 *
 * @author  cs
 * @since   25.5.2016
 * @version 1.0
 */
const componentList = {

	// keep lists of tried loads to prevent multiple loader executions
	componentsLoaded: {},
	templatesLoaded: {},
	stylesLoaded: {},

	// list of components (componentKey => Component)
	components: {},
	// list of templates (componentKey => templateFunction)
	templates: {},
	// TODO: may be moved to routeController?!
	// this is a list of routes which will be saved during build ( hashOfRoute => route )
	routeStore: {},

	/**
	 * this init function is used to be overwritten by the server- or client-ComponentList
	 */
	init: function(){},

	/**
	 * this function is used to load the component, template and style of one specific Component and its' subComponents.
	 *
	 * @param   componentGroup    array - component group identifier
	 * @returns if a at least a component or a template does exist after this function call
	 */
	load: function(componentGroup){
		// init
		var key = this.buildKey(componentGroup);
		var templateFound = true;
		var componentFound = true;

		// load template
		if(!this.templates[key] && (templateFound = this.templatesLoaded[key]) === undefined) templateFound = this.loadTemplate(componentGroup, key);

		// load componentGroup
		if(!this.components[key] && (componentFound = this.componentsLoaded[key]) === undefined && (componentFound = this.loadComponent(componentGroup, key))){

			// init components' base config
			var config = {};

			// if a component has only been coded to sanitize includes it has not been instantiated: so mark it as includeOnlyComponent
			var nrOfComponentFamilies   = utils.collectionSize(this.components[key]);
			if(nrOfComponentFamilies == 1 && this.components[key].methods){
				var nrOfComponentMethods = utils.collectionSize(this.components[key].methods);
				if(nrOfComponentMethods == 1 && this.components[key].sanitizeInclude){
					config.includeOnlyComponent = true;
				}
			}

			// mark if component has an includeSanitize-method
			config.hasIncludeSanitizer = componentList.components[key].methods && typeof(componentList.components[key].methods.sanitizeInclude) === 'function';

			// set the base config parameters
			this.components[key].config = utils.replace(this.components[key].config || {}, config);
		}

		// load style
		if(this.stylesLoaded[key] === undefined) this.loadStyle(componentGroup, key);

		// return if at least a component or a template exists after this function call
		return componentFound || templateFound;
	},

	/**
	 * this function is used to register either the given component or the extended component in case of a given "extends"-flag.
	 *
	 * @param componentGroup    array - componentGroup (for details have a closer look at load())
	 * @param component         object - component data
	 * @returns boolean - success
	 */
	loadExtendedComponent: function(componentGroup, component){
		// init
		try {
			const key = this.buildKey(componentGroup)

			if (utils.isEmpty(component.extends)) {
				this.components[key] = component
				return true
			}
			else {
				// save extension definitions to be able to use their relative paths for extending single elements like templates or components
				component._extends = utils.simpleCopy(component.extends)

				// prepare extension component parameters
				const extensionComponentGroup = this.normalizeComponentGroup(utils.concat(componentGroup, component.extends))
				const extensionKey = this.buildKey(extensionComponentGroup)

				// load extension if necessary
				this.load(extensionComponentGroup)

				// set extensionComponentClass
				component.extensionComponentClass = ''
				if(this.components[extensionKey] && !utils.isEmpty(this.components[extensionKey].extensionComponentClass)){
					component.extensionComponentClass += this.components[extensionKey].extensionComponentClass + ' '
				}
				component.extensionComponentClass += extensionKey

				// TODO: multiple inheritance including missing hook gaps causing problems because of the front-to-back strategy
				// prepare triggers
				const hooks = this.prepareTriggers(extensionKey, component)

				// prepare handlers if possible
				// NOTE: it is possible to extend components without a js-file. therefor, the extended component may not be set at all.
				const handlers = ((this.components[extensionKey] || {}).handlers || []).concat(component.handlers || [])

				// set extended component
				this.components[key] = utils.replace(utils.merge(this.components[extensionKey], component), { hooks, handlers })
				// prevent _extends flag from being merged
				this.components[key]._extends = component._extends

				// grab secure routes based on filesystem
				this.grabSecureRoutes(this.components[key])

				// prevent extend load circle
				// TODO: stop circles of more than two classes if possible
				const nextExtensionKey = this.buildKey(this.normalizeComponentGroup(utils.concat(componentGroup, this.components[key].extends)))
				if (nextExtensionKey == extensionKey || nextExtensionKey == key) {
					this.components[key].extends = ''
				}
			}

			return true
		}
		catch(error){
			console.log('------------- ERROR ', error);
		}

		return false;
	},

	/**
	 * this function is used to be overwritten by server- or client-componentList and should load a template.
	 * the function returns false if no load is possible or necessary and true otherwise.
	 *
	 * @param   componentGroup      array - componentGroup (for details have a closer look at load())
	 * @param   key      			string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	loadTemplate: function(componentGroup, key){
		return false;
	},

	/**
	 * this function is used to be overwritten by server- or client-componentList and should load a component.
	 * the function returns false if no load is possible or necessary and true otherwise.
	 *
	 * @param   componentGroup      [] | string - componentGroup (for details have a closer look at load())
	 * @param   key      			string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	loadComponent: function(componentGroup, key){
		return false;
	},

	/**
	 * this function is used to be overwritten by server- or client-componentList and should load a style.
	 * the function returns false if no load is possible or necessary and true otherwise.
	 *
	 * @param   componentGroup      [] | string - componentGroup (for details have a closer look at load())
	 * @param   key      			string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	loadStyle: function(componentGroup, key){
		return false;
	},

	/**
	 * this function is used to build a component key out of its' componentGroup
	 *
	 * @param   componentGroup           array - componentGroup
	 * @returns string
	 */
	buildKey: function(componentGroup){
		if(componentGroup.length > 0 && componentGroup[0] === '/') return componentGroup.slice(1).join('_');
		return componentGroup.join('_');
	},

	/**
	 * this function is used to build a components' path out of its' componentGroup
	 *
	 * @param   componentGroup           array - componentGroup
	 * @returns string
	 */
	buildPath: function(componentGroup){
		return componentGroup.join('/');
	},

	/**
	 * this function is used to normalize a components' group
	 *
	 * @param   componentGroup           [] | string - componentGroup
	 * @returns []
	 */
	normalizeComponentGroup: function(componentGroup){
		if(!componentGroup)						return [];
		if(typeof(componentGroup) === 'string') return [componentGroup];
		if(Array.isArray(componentGroup)){
			var result = [], resultLen = 0, g = 0, len = componentGroup.length;

			for(g = 0; g < len; g++){
				if(componentGroup[g] === '/') 		result = [];
				else if(componentGroup[g] === '..') result.pop();
				else if(componentGroup[g] !== '.') 	result.push(componentGroup[g]);
			}

			return result;
		}

		return [];
	},

	/**
	 * this function returns true if the given component group corresponds to a relative path
	 *
	 * @param   componentGroup     array - componentGroup
	 * @returns boolean
	 */
	isRelativeComponentGroup: function(componentGroup){
		return (
			componentGroup[0] === '.'
			||
			componentGroup[0] === '..'
		);
	},

	/**
	 * this function is used to resolve component groups which could be relative within their context (parent and / or the parents extensions)
	 *
	 * @param   componentGroup              array - component group which should be resolved
	 * @param   parentComponentGroup        array - component group which should be used as parent if the componentGroup parameter equates to a relative one
	 * @param   extensionComponentGroup     array - optional component group of the parents extension, which can be used for cascaded relative searches within the inheritance ancestor components
	 * @returns mixed - the found absolute component group or false in an error case
	 */
	resolveComponentGroup: function(componentGroup, parentComponentGroup, extensionComponentGroup){
		// component found?
		if(this.load(componentGroup)){
			return componentGroup;
		}
		else {
			// relative component in parent component found?
			var testComponentGroup = utils.concat(utils.simpleCopy(parentComponentGroup).slice(0, parentComponentGroup.length - 1), componentGroup);
			if(this.load(testComponentGroup)){
				return testComponentGroup;
			}
			// relative component in extension component found?
			else if(!utils.isEmpty(extensionComponentGroup)){
				// load extensionComponent if necessary
				if(this.load(extensionComponentGroup)){
					var extensionComponentKey = this.buildKey(extensionComponentGroup);
					if(typeof(this.components[extensionComponentKey]) !== 'undefined'){
						return this.resolveComponentGroup(componentGroup, extensionComponentGroup, this.components[extensionComponentKey].extends || undefined);
					}
				}
			}
		}

		console.error('componentList.resolveGroup() - ' + componentGroup.join('_') + ' cannot be resolved!');
		return false;
	},

	/**
	 * this function may be used to prepare the list of hooks (triggers).
	 * NOTE: may be overwritten (this is actually used by the client).
	 *
	 * @param extensionKey		String - component extension key
	 * @param component			object - component
	 */
	prepareTriggers: function(extensionKey, component){
		return {};
	},

	/**
	 * this function is used to remove the real action routes from the components and replace them with a hash code
	 *
	 * @param   leaf                		object - componentTree element
	 * @param   parentRoutePath     		string - path to parent route element
	 * @param   [overridePrivilegeCode]		string - optional parameter needed to use this overridePrivilegeCode instead of the leafs' one
	 * 										NOTE: especially useful in cases like model.field.resource-actions usages in the name of another service.
	 * 										(e.g., the cms loads resources of model.fields of components which exists for the assigned web-service)
	 * @param   [overrideScope]				string - optional parameter needed to use this scope instead of the leafs' one
	 * 										NOTE: especially useful in cases like model.field.resource-actions usages in the name of another service.
	 * 										(e.g., the cms loads resources of model.fields of components which exists for the assigned web-service)
	 * @returns object - leaf
	 */
	prepareActions: function(leaf, parentRoutePath, overridePrivilegeCode, overrideScope){
		// prepare normal actions
		utils.forEach(leaf.actions, function(action, actionName){
			componentList.prepareAction(leaf, action, parentRoutePath, overridePrivilegeCode, overrideScope);
		});

		if(!utils.isEmpty(leaf.resourceData)){
			// prepare resource actions directly within resourceData
			utils.forEach(leaf.resourceData.actions, function(action, actionName){
				componentList.prepareAction(leaf, action, undefined, overridePrivilegeCode, overrideScope);
			});

			// prepare resource actions within resourceData-list if necessary
			utils.forAll(leaf.resourceData, function(resource, key, collection, isCollection){
				if(isCollection){
					utils.forEach(resource.actions, function(action, actionName){
						componentList.prepareAction(leaf, action, undefined, overridePrivilegeCode, overrideScope);
					});

					return 'breakRecursion';
				}
			});
		}

		// prepare model actions within model-list (e.g., used in route-picker and other templateAtoms) if necessary
		utils.forAll(leaf.model, function(value, key, collection, isCollection){
			if(isCollection){
				utils.forEach(value.actions, function(action, actionName){
					componentList.prepareAction(leaf, action, undefined, overridePrivilegeCode, overrideScope);
				});

				return 'breakRecursion';
			}
		});

		return leaf;
	},

	// TODO: DOCS
	prepareAction: function(leaf, action, parentRoutePath, privilegeCode, scope){
		if(leaf && utils.isCollection(leaf)){
			parentRoutePath 	= parentRoutePath || leaf._routePath;
			privilegeCode   	= privilegeCode || leaf.privilegeCode;
			if(!scope) scope	= leaf.scope;
		}

		utils.forEach(action.source || [], (source, sourceName) => {
			// prepare sources' resourceTemplates
			utils.forAll(action.source[sourceName], (value, key, collection) => {
				if(key === 'resourceTemplate'){
					utils.refReplace(
						collection,
						utils.action.getResourceTemplate(value),
						{
							resourceTemplate: undefined
						}
					);
					return 'breakRecursion';
				}
			});

			// hide resource route and middleware behind hash value
			this.grabResource(action.source[sourceName], parentRoutePath, privilegeCode, scope, Boolean(action.isFieldAction));

			// hide componentRoute behind hash value and prevent doubled hashes
			if(action.source[sourceName].componentRoute && !componentList.routeStore[action.source[sourceName].componentRoute]){
				const route   = '/' + action.source[sourceName].componentRoute.replace(/^\//, '');
				const hash 	= utils.md5(route);
				action.source[sourceName].componentRoute = hash;
				componentList.routeStore[hash] = route;
			}

			// hide shadowComponentRoute behind hash value and prevent doubled hashes
			if(action.source[sourceName].shadowComponentRoute && !componentList.routeStore[action.source[sourceName].shadowComponentRoute]){
				const route   = action.source[sourceName].shadowComponentRoute.replace(/^\//, '');
				const hash 	= utils.md5(route);
				action.source[sourceName].shadowComponentRoute = hash;
				componentList.routeStore[hash] = route;
			}

			// prepare cascaded actions if necessary
			utils.forEach((action.source[sourceName].componentData || {}).actions || {}, (childAction, childActionKey) => {
				componentList.prepareAction(undefined, action.source[sourceName].componentData.actions[childActionKey], parentRoutePath, privilegeCode, scope);
			});

			// resolve relative action component paths if necessary
			if(
				leaf
				&&
				!utils.isEmpty((action.source[sourceName].componentData || {}).component)
				&&
				componentList.isRelativeComponentGroup(action.source[sourceName].componentData.component)
			){
				action.source[sourceName].componentData.component =
					componentList.resolveComponentGroup(
						action.source[sourceName].componentData.component,
						leaf.component,
						leaf.extends || undefined
					)
				;
			}
		});
	},

	/**
	 * this function is used to hide the resource-route behind it's hash within the routeStore in case of components.
	 *
	 * @param   collection          	object - componentTree leaf or another resourceConfig owner
	 * @param   parentRoutePath     	string - path to parent route element
	 * @param   privilegeCode       	string - privilegeCode of resources' parent leaf
	 * @param   componentScope			string - optional - scope of this action
	 * @param   [preventAuthorization]	boolean - optional - should scope and privilegeCode be prevented?
	 * @returns {} - modified collection
	 */
	grabResource: function(collection, parentRoutePath, privilegeCode, componentScope, preventAuthorization){
		if(!utils.isEmpty(collection.resourceConfig)){
			// hide resource configuration behind hash value if necessary
			var config = utils.simpleCopy(collection.resourceConfig);

			// log a second config preparation of the same resourceConfig without any presence within the routeStore.
			if(typeof config === 'string'){
				if(!this.routeStore[config]){
					console.error('WARNING: MISSING routeStore entry:', config)
				}

				return collection
			}

			if(preventAuthorization) {
				config.overwriteAuth 	= true;
			} else {
				config.privilegeCode    = collection.privilegeCode || privilegeCode;

				// prevent resource's scope from being overwritten by componentScope if there is none
				if(componentScope){
					config.scope = componentScope;
				}
			}

			// prepare additional resource configs if necessary
			if(!utils.isEmpty(config.additionalResourceConfigs)){
				utils.forEach(config.additionalResourceConfigs, function(additionalConfig, additionalConfigKey){
					if(preventAuthorization) {
						config.additionalResourceConfigs[additionalConfigKey].overwriteAuth = true;
					} else {
						// TODO: should additionalResourceConfigs privilegeCode survive another privilegeCode within its parent resource?
						config.additionalResourceConfigs[additionalConfigKey].privilegeCode = config.privilegeCode;
						config.additionalResourceConfigs[additionalConfigKey].scope 		= config.scope;
					}
				});
			}

			var resourceHash = utils.collectionMD5(config)
			var hash = resourceHash;
			config._routePath = parentRoutePath;
			hash += `pRP:${parentRoutePath}`
			// prepare additional resource configs if necessary
			if(!utils.isEmpty(config.additionalResourceConfigs)){
				utils.forEach(config.additionalResourceConfigs, function(additionalConfig, additionalConfigKey){
					config.additionalResourceConfigs[additionalConfigKey]._routePath = parentRoutePath;
					hash += `aCK:${additionalConfigKey}`
				});
			}

			hash = utils.md5(hash)
			collection.resourceConfig   = hash
			config.hash 				= hash
			config.resourceHash 		= resourceHash
			this.routeStore[hash]		= config
		}

		return collection;
	},

	/**
	 * this function is used to hide static routes which should be secured behind its' hash within the routeStore in case of components.
	 *
	 * @param   leaf          		object - componentTree leaf || form-model-field
	 * @param   privilegeCode       string - privilegeCode of resources' parent leaf
	 * @param   componentScope		string - optional - scope of this action
	 * @returns {} - modified leaf
	 */
	grabSecureRoutes: function(leaf, privilegeCode, componentScope){
		// prepare secureRoutes if necessary
		if(
			leaf.config &&
			leaf.config.secureRoute &&
			// check if secureRoute has already been grabbed
			!this.routeStore[leaf.config.secureRoute]
		){
			const config = {
				route: 			leaf.config.secureRoute,
				privilegeCode: 	privilegeCode || '',
				scope: 			componentScope || '',
			}
			const hash 					= utils.md5(JSON.stringify(config))
			config.hash 				= hash
			this.routeStore[hash]   	= config
			leaf.config.secureRouteHash = hash
		}

		return leaf
	},

	/**
	 * looks for template according to the given componentKey within the whole inheritance chain from the actual component to the earliest ancestor.
	 * NOTE: if no template could be found a dummy template function will be returned.
	 *
	 * @param   componentKey    string - component key
	 * @returns function - template
	 */
	getTemplate: function(componentKey){
		if(componentKey){
			// template found
			if(this.templates[componentKey]) return this.templates[componentKey];

			// component found
			if(this.components[componentKey] && this.components[componentKey]._extends){
				// set shortcut for later requests
				return (this.templates[componentKey] = this.getTemplate(this.buildKey(this.normalizeComponentGroup(this.components[componentKey]._extends))))
			}
		}

		// resourceLoaderComponents may be used solely for the purpose of resourceLoading.
		// if one does not intend to render a component the templateSrcFile may be left empty.
		// in this case a logEntry is neither useful nor necessary.
		if(componentKey) console.error(`UNDEFINED_TEMPLATE_USAGE_DETECTED: "${componentKey}"`);

		// return fallback
		return (() => `<!-- UNDEFINED_TEMPLATE_USAGE_DETECTED: "${componentKey}" -->`)
	}
};

module.exports = componentList;
